import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import OldNoteEdit from './noteEdit';
import { DraftNoteForm } from './presets/DraftNoteForm';
import { PopupNoteForm } from './presets/PopupNoteForm';

export type Props = {
  note?: ClientProfileContentItem;
  clientId: string;
  isEditMode?: boolean;
  inputOpen?: boolean;
  noteId?: string;
  context: 'popup' | 'noteSection';
};

// NoteEdit component with feature flag
// Uses new composable NoteForm when enableBillingUpdates is true
export const NoteEdit = (props: Props) => {
  const { enableBillingUpdates } = useFlags();

  if (!enableBillingUpdates) {
    return <OldNoteEdit {...props} />;
  }

  // Use new composable NoteForm based on context
  if (props.context === 'popup') {
    return <PopupNoteForm clientId={props.clientId} note={props.note} />;
  }

  // Default to DraftNoteForm for noteSection context
  return <DraftNoteForm clientId={props.clientId} note={props.note} expanded={props.inputOpen} />;
};
